export default __webpack_public_path__ + "static/logo-5dddd4212130210af3425b229bab524e.png";